<template>
<v-app>
<resizable-page>
  <template v-slot:table="tableProps">
  <v-card>
    <v-card-title>
      
      <v-spacer></v-spacer>
      <!-- <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field> -->
      <div class="d-flex">
        <v-select
        style=" max-width: 150px;"
          :items="option_filter"
          label="Select"
          v-model="searchCategory"
          @change="search=''"
           item-text="text"
          item-value="value"
        
          class="ma-2"
        hide-details
        >
        </v-select>
      <v-text-field
        :disabled="!searchCategory"
        v-model="search"
        label="Search"
          class="ma-2"
        single-line
        hide-details
      >
      </v-text-field>
        <v-btn :disabled="!search" class="mt-5"  small color="primary" @click="searchButton"> <v-icon>mdi-magnify</v-icon> </v-btn>
        <v-btn v-if="searchValue" class="mt-5 ml-1" dark small color="red" @click="clearSearchButton">Clear</v-btn>
    </div>
    </v-card-title>
    <v-data-table
      mobile-breakpoint
      :headers="headers"
      :items="table"
      :loading="loadTable"
      loading-text="Loading... Please wait"
      ref="vTable"
      :height="tableProps.tableHeight"
      fixed-header
      :options.sync="options"
      :server-items-length="totalDataTable"
      :page="page"
      :pageCount="numberOfPages"
      :footer-props="{ 'items-per-page-options': [15, 25, 50] }"
     > 
    <template v-slot:item="{ item }">
        <tr  @click="onSelect(item)">
            <td>{{item.vehicle_door_no}}</td>
            <td>{{item.vehicle_plate_no}}</td>
            <td>
              <span v-if="item.vehicle_status==0">Registered</span>
              <span v-if="item.vehicle_status==1">Waiting Approval</span>
              <span v-if="item.vehicle_status==2">Rejected</span>
              <span v-if="item.vehicle_status==3">Waiting PKO</span>
              <span v-if="item.vehicle_status==4">Active</span>
              <span v-if="item.vehicle_status==5">Payment Completed</span>
              <span v-if="item.vehicle_status==6">Terminate By Payment</span>
            </td>

            
            
        </tr>
    </template>
    
    </v-data-table>
  </v-card>
    </template>
  </resizable-page>
  </v-app>
</template>

<script>
import vuetify from '@/plugins/vuetify'
import { ResizablePage } from "@/components";

  export default {
    vuetify,
    components: {ResizablePage
  },
     props: {
    data_id: null,
    },
    data () {
      return {
        brand_id: null,
         mounted: true,
        loadTable: false,
        page: 1,
        options: {},
        totalDataTable: 0,
        numberOfPages: 0,
        searchValue:null,
        searchCategory:null,
        search: '',
        headers: [
          { text: 'Vehicle Vehicle No', value: 'vehicle_door_no' },
          { text: 'Plat No', value: 'vehicle_plate_no' },
          { text: 'Status', value: 'vehicle_status' },
        ],
         option_filter: [ { text: 'Vehicle Vehicle No', value: 'vehicle_door_no' },
          { text: 'Plat No', value: 'vehicle_plate_no' },
          ],
        table: [],
      }
    },
    watch: {
    options: {
      handler() {
        if (!this.mounted) {
          this.getList();
        }
      },
    },
    deep: true,
  },
  async mounted() {
    this.mounted = false

    },
    async created() {
      
    // this.getList();
    },
     methods: {
       // ambil data yang dibutuhkan
    async getList() { 

      this.loadTable = true;
      const { page, itemsPerPage, sortBy, sortDesc } = this.options;
      console.log(this.options);
      let pageNumber = page;

      let itemsPerPageNumber = itemsPerPage;

      var query = { page: { number: pageNumber, size: itemsPerPageNumber } };
      query.filter = { vehicle_status: 3 ,  vehicle_business_unit: 1};
      if (sortBy.length != 0) {
        var sort = sortBy[0];
        if (sortDesc[0]) {
          sort = "-" + sortBy[0];
        }
        query.sort = sort;
      }

      if (this.searchValue && this.searchCategory) {
           if (query.filter) {
              Object.assign(query.filter, { [this.searchCategory]: this.searchValue});
            } else {
             
        query.filter = { [this.searchCategory]: this.searchValue };
            }
      }

    

    

     

      
      
         await this.$store.dispatch("fms_vehicle/list", query);
      this.table = await this.$store.getters["fms_vehicle/list"];
      var pageMeta = await this.$store.getters["fms_vehicle/page"];

      
      
      this.totalDataTable = pageMeta.total;
      this.numberOfPages = pageMeta["to"];
      this.loadTable = false;
    },

     searchButton(){
      this.searchValue = this.search
      this.getList()
    },
    clearSearchButton(){
      this.searchValue = null
      this.search = null
      this.searchCategory = null
      this.getList()
    },


    //fungsi yang ada di parent di panggil saat memilih row di table
    onSelect (item) {
      this.$parent.$parent.$parent.$parent.modalCloseListVehicle(item,this.item)
      },

      

     },

     
  }
</script>
<style>
.v-application--wrap {
  min-height: unset;
}
.v-list-item__title {
    font-size: 0.8rem;
}
.v-menu__content{
    z-index: 10 !important;
}
table > tbody > tr > td.fixed:nth-child(1), 
  table > thead > tr > th.fixed:nth-child(1) {
    position: sticky !important; 
    position: -webkit-sticky !important; 
    left: 0; 
    z-index: 9998;
    background: white;
  }
  table > thead > tr > th.fixed:nth-child(1) {
    z-index: 9999;
  }
</style>